import { render } from "./weeklyRankRewardsCharm.vue?vue&type=template&id=36b6f9ec"
import script from "./weeklyRankRewardsCharm.vue?vue&type=script&lang=js"
export * from "./weeklyRankRewardsCharm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__